module.exports = __webpack_public_path__ + "img/brandenburg_3.e43dbbd8.png";